module.exports = "/* .mat-label{\r\n    margin-right: 20px;\r\n} */\n"